import React, { Component } from "react";
import DigiD from "./digid";
import OidcMicrosoft from "./oidcMicrosoft";
import Otp from "./otp";
import Sms from "./sms";
import EmailAccessCode from "./emailAccessCode";
import ClientCert from "./clientCert";
import PasswordAuth from "./password";
import Uzi from "./uzi";
import axios from "axios";
import classnames from "classnames";
import { connect } from "react-redux";
import settings from "client.settings.json";
import { translate } from "reducers/i18n";
import "./login.css";
import { getMappings } from "pages/getPageTemplatesMappings";
import { Error } from "./error";

const mapTypeToTabHeader = {
  clientCert: "Client certificate",
  digid: "DigiD",
  emailAccessCode: "_email",
  oidcMicrosoft: "Microsoft OpenID",
  otp: "Authenticator",
  password: "passwordTitle",
  phoneNumber: "SMS",
  uzi: "UZI-pas",
};

class Login extends Component {
  constructor(props) {
    super(props);

    let query = {};
    let queryString = this.props.location.search?.substring(1);
    let matchQueryParam = /(?<key>[^=]+?)(?:=(?<value>[^&]*?))?(&|$)/y;
    let matchQueryParamResult;

    while ((matchQueryParamResult = matchQueryParam.exec(queryString))) {
      let { key, value } = matchQueryParamResult.groups;
      query[key] = decodeURI(value);
    }

    this.state = {
      loading: false,
      messageIdIsValid: false,
      authenticators: [],
      invalidAuthenticators: [],
      error: null,
      activeTab: query.method,
      availableAuthenticatorTypes: [
        { type: "clientCert", weight: 1 },
        { type: "oidcMicrosoft", weight: 2 },
        { type: "otp", weight: 3 },
        { type: "digid", weight: 4 },
        { type: "emailAccessCode", weight: 5 },
        { type: "password", weight: 6 },
        { type: "phoneNumber", weight: 7 },
        { type: "uzi", weight: 8 },
      ],
      query,
      email: "",
      mappings: {},
      bgCol: "#4098ff",
    };

    this.hideLoginInstruction = this.hideLoginInstruction.bind(this);
    this.headerPanel = React.createRef();
  }

  componentDidMount() {
    this.validateMessageId();
    getMappings("login", this.props.match.params.tenantId)
      .then((mappings) => {
        this.setState({ mappings: mappings });

        if (this.headerPanel?.current) {
          const computedStyle = window.getComputedStyle(
            this.headerPanel.current
          );
          const backgroundColor = computedStyle.backgroundColor;
          this.setState({ bgCol: backgroundColor });
        }
      })
      .catch((error) => console.log(error));
  }

  hideLoginInstruction(authenticator) {
    this.setState((previous) => ({
      invalidAuthenticators: [...previous.invalidAuthenticators, authenticator],
    }));
  }


  rgbToHex(rgb) {
    const result = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/.exec(rgb);
    const r = parseInt(result[1], 10);
    const g = parseInt(result[2], 10);
    const b = parseInt(result[3], 10);

    const toHex = (n) => {
      const hex = n.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };

    return `${toHex(r)}${toHex(g)}${toHex(b)}`;
  }

  isLightBackground(color) {
    const hex = color.replace("#", "");
    const [r, g, b] = [0, 2, 4].map((offset) =>
      parseInt(hex.substring(offset, offset + 2), 16)
    );
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5;
  }

  render() {
    let {
      loading,
      error,
      address,
      authenticators,
      typesOfAuthenticators,
      query,
    } = this.state;
    let { tenantId, messageId } = this.props.match.params;
    let setError = (error) => this.setState({ error });
    let digidAuthenticators = authenticators.filter(
      ({ type }) => type === "digid"
    );
    let otpAuthenticators = authenticators.filter(({ type }) => type === "otp");
    let phoneNumberAuthenticators = authenticators.filter(
      ({ type }) => type === "phoneNumber"
    );
    let emailAccessCodeAuthenticators = authenticators.filter(
      ({ type }) => type === "emailAccessCode"
    );
    let uziAuthenticators = authenticators.filter(({ type }) => type === "uzi");
    const oidcAuthenticators = authenticators.filter(
      ({ type }) => type === "oidcMicrosoft"
    );
    const clientCertAuthenticators = authenticators.filter(
      ({ type }) => type === "clientCert"
    );
    const passwordAuthenticators = authenticators.filter(
      ({ type }) => type === "password"
    );

    const page_name =
      this.state.activeTab === "emailAccessCode"
        ? "E_DELIVERY_LOGIN_PAGE_EMAIL"
        : this.state.activeTab === "otp"
        ? "E_DELIVERY_LOGIN_PAGE_AUTHENTICATOR"
        : this.state.activeTab === "clientCert"
        ? "E_DELIVERY_LOGIN_PAGE_CLIENTCERT"
        : this.state.activeTab === "oidcMicrosoft"
        ? "E_DELIVERY_LOGIN_PAGE_OIDC_MS"
        : this.state.activeTab === "digid"
        ? "E_DELIVERY_LOGIN_PAGE_DIGID"
        : this.state.activeTab === "uzi"
        ? "E_DELIVERY_LOGIN_PAGE_UZI"
        : "E_DELIVERY_LOGIN_PAGE_SMS";
    const currentHandlebars = this.state.mappings[page_name];

    return (
      <div className="loginForm panel">
        <div
          className="panelHeader header_fontFamily"
          ref={this.headerPanel}
        >
          {currentHandlebars ? (
            <h1
              dangerouslySetInnerHTML={{ __html: currentHandlebars?.header }}
            />
          ) : (
            <h1>&nbsp;</h1>
          )}
        </div>
        <div>
          {loading && <p>{translate("_isLoading")}...</p>}
          {error ? (
            <Error 
              error={this.state.error}
              tenantId={this.props.match.params.tenantId}
            />
          ) : !!authenticators.length && !!currentHandlebars ? (
            <>
              <ul className="nav nav-tabs pt-3 px-3 border-top bg-light text-dark">
                {typesOfAuthenticators.map((type) => {
                  {
                    /* {["clientCert", "otp", "digid", "uzi", "emailAccessCode", "password",].map((type) => { */
                  }
                  const name = translate(mapTypeToTabHeader[type]);

                  return (
                    <li
                      className="nav-item"
                      key={type}
                      onClick={() => this.setState({ activeTab: type })}
                    >
                      <span
                        className={classnames("nav-link", {
                          active: this.state.activeTab === type,
                        })}
                      >
                        {name}
                      </span>
                    </li>
                  );
                })}
              </ul>
              <div className="authenticator bg-white">
                {this.state.activeTab === "clientCert" ? (
                  <ClientCert
                    setError={setError}
                    tenantId={tenantId}
                    messageId={messageId}
                    query={query}
                    address={address}
                    authenticators={clientCertAuthenticators}
                    hideLoginInstruction={this.hideLoginInstruction}
                    mappings={this.state.mappings}
                  />
                ) : this.state.activeTab === "otp" ? (
                  <Otp
                    authenticators={otpAuthenticators}
                    mappings={this.state.mappings}
                    bgCol={this.state.bgCol}
                  />
                ) : this.state.activeTab === "digid" ? (
                  <DigiD
                    setError={setError}
                    tenantId={tenantId}
                    messageId={messageId}
                    query={query}
                    authenticators={digidAuthenticators}
                    hideLoginInstruction={this.hideLoginInstruction}
                    mappings={this.state.mappings}
                  />
                ) : this.state.activeTab === "uzi" ? (
                  <Uzi
                    setError={setError}
                    tenantId={tenantId}
                    messageId={messageId}
                    query={query}
                    address={address}
                    authenticators={uziAuthenticators}
                    hideLoginInstruction={this.hideLoginInstruction}
                    mappings={this.state.mappings}
                  />
                ) : this.state.activeTab === "emailAccessCode" ? (
                  <EmailAccessCode
                    setError={setError}
                    tenantId={tenantId}
                    messageId={messageId}
                    query={query}
                    address={address}
                    authenticators={emailAccessCodeAuthenticators}
                    hideLoginInstruction={this.hideLoginInstruction}
                    mappings={this.state.mappings}
                    email={this.state.authenticators.find(a => a.type === "emailAccessCode")?.publicValue}
                  />
                ) : this.state.activeTab === "oidcMicrosoft" ? (
                  <OidcMicrosoft
                    setError={setError}
                    tenantId={tenantId}
                    messageId={messageId}
                    authenticators={oidcAuthenticators}
                    mappings={this.state.mappings}
                  />
                ) : this.state.activeTab === "password" ? (
                  <PasswordAuth
                    setError={setError}
                    tenantId={tenantId}
                    messageId={messageId}
                    authenticators={oidcAuthenticators}
                    mappings={this.state.mappings}
                  />
                ) : (
                  <Sms
                    setError={setError}
                    tenantId={tenantId}
                    messageId={messageId}
                    query={query}
                    authenticators={phoneNumberAuthenticators}
                    hideLoginInstruction={this.hideLoginInstruction}
                    mappings={this.state.mappings}
                    email={this.state.email}
                    bgCol={this.state.bgCol}
                  />
                )}
              </div>
            </>
          ) : (
            <p className="panelContent body_fontFamily">
              {translate("_isLoading")}
            </p>
          )}
        </div>
      </div>
    );
  }

  validateMessageId() {
    let { activeTab } = this.state;
    this.setState({ loading: true });
    axios({
      url: settings.api + "/api/login/validatemessageid",
      method: "post",
      data: {
        messageId: this.props.match.params.messageId,
      },
    }).then(
      (response) => {
        if (response && response.data) {
          let { address, authenticators } = response.data;

          let typesOfAuthenticators = authenticators
            ?.map((a) => a.type)
            .filter(function (item, pos, self) {
              return self.indexOf(item) === pos;
            })
            .sort(
              (authA, authB) =>
                (this.state.availableAuthenticatorTypes.find(
                  (a) => a.type === authA
                )?.weight || 10) -
                (this.state.availableAuthenticatorTypes.find(
                  (a) => a.type === authB
                )?.weight || 10)
            );

          if (!activeTab && typesOfAuthenticators) {
            activeTab = typesOfAuthenticators?.[0];
          }

          this.setState({
            loading: false,
            messageIdIsValid: true,
            address,
            authenticators,
            typesOfAuthenticators,
            activeTab,
          });
        } else {
          this.setState({ loading: false, messageIdIsValid: false });
        }
      },
      (error) => {
        this.setState({ loading: false, error });
      }
    );
  }
}

const mapStateToProps = (state) => state.i18n;
export default connect(mapStateToProps)(Login);
